import { Group, Rect, Text } from 'react-konva';
import { Size } from '../../../../core/types/ui/size';
import { IPosition2d } from '../../../../core/types/ui/position';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { UseCellSelection } from '../../../hooks/useCellSelection';
import { SelectionCell, SelectionOperationType } from '../../../types';
import { indexToColumnLetter } from '../../../utils/area/area';
import { useMemo } from 'react';

interface ColumnHeaderCellProps
  extends Size,
    IPosition2d,
    Pick<UseCellSelection, 'onCellMouseDown' | 'onActiveHeaderMouseDown'>,
    Pick<UseSheetTheme, 'stroke' | 'textColor' | 'fill'> {
  index: number;
  isSelected: boolean;
  underSelection: boolean;
  isActiveSelection: boolean;
  zoom: number;
}
const ColumnHeaderCell: React.FC<ColumnHeaderCellProps> = ({
  x,
  y,
  width,
  height,
  index,
  fill,
  stroke,
  textColor,
  underSelection,
  isSelected,
  isActiveSelection,
  zoom,
  onCellMouseDown,
  onActiveHeaderMouseDown,
}) => {
  const background = () => (
    <Rect
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      strokeWidth={1 * zoom}
      // opacity={0.2}
      hitStrokeWidth={0}
    />
  );

  const text = () => (
    <Text
      width={width}
      height={height}
      align="center"
      verticalAlign="middle"
      fontSize={Math.floor(height / 2)}
      // fontSize={12}
      text={indexToColumnLetter(index)} //index.toString()
      fill={textColor}
      fontStyle={underSelection ? 'bold' : 'normal'}
    />
  );

  return useMemo(
    () => (
      <Group
        x={x}
        y={y}
        onMouseDown={(e) =>
          isActiveSelection
            ? onActiveHeaderMouseDown(e, SelectionOperationType.ColMove, index)
            : onCellMouseDown(e, SelectionCell.Column, { ci: index, ri: 0 })
        }
        onContextMenu={(e) =>
          onCellMouseDown(e, SelectionCell.Column, { ci: index, ri: 0 })
        }
      >
        {background()}
        {text()}
      </Group>
    ),
    [
      x,
      y,
      width,
      height,
      index,
      fill,
      stroke,
      textColor,
      underSelection,
      isSelected,
      isActiveSelection,
      onCellMouseDown,
    ]
  );
};

export default ColumnHeaderCell;
